import EditReservationForm from '@/features/reservations/components/EditReservationForm';
import type { Reservation } from '@restaurant/api-client';
import { Popup } from 'framework7-react';
import { useState } from 'react';

interface Props {
  opened: boolean;
  onClose: () => void;
  reservation: Reservation;
}

export default function EditReservationPopup({ opened, onClose, reservation }: Props) {
  const [mounted, setMounted] = useState(opened);
  if (opened && !mounted) setMounted(true);

  return (
    <Popup
      opened={opened}
      onPopupClosed={() => {
        setMounted(false);
        onClose();
      }}
    >
      {mounted && <EditReservationForm reservation={reservation} onClose={onClose} />}
    </Popup>
  );
}
